module.exports = __webpack_public_path__ + "front/img/btn.29ddea9d.png";